export default __webpack_public_path__ + "static/media/011-taj mahal.3d6971ef.svg";